import React, { Component, useEffect, useState } from "react";
import ComponentSupportMobile from "./ComponentSupportMobile";
import ComponentSupportWeb from "./ComponentSupportWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentInvoice = () => {
  const gaEventTracker = useAnalyticsEventTracker("Invoice");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Invoice",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentSupportWeb></ComponentSupportWeb>
      </BrowserView>
      <MobileView>
        <ComponentSupportMobile></ComponentSupportMobile>
      </MobileView>
    </>
  );
};
export default ComponentInvoice;
